@if (isSuccess()) {
  <app-badge [color]="'light-success'"
             [message]="'✓ ' +('GLOBAL_BTN_OK' | translate)" />
} @else {
  <app-badge [color]="'light-danger'"
             [message]="'✗ ' + ('GLOBAL_BTN_NOK' | translate)" />
}
